export default __webpack_public_path__ + "static/media/platform_logo.230bb7e8.svg";